import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind class lists (shadcn-style helper used by the ported 21st.dev components). */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
